<template>
    <div class="popup visible" id="cancel-popup">
        <div class="popup-box">
            <p class="h2 title">{{title}}</p>

            <div class="buttons-box">
                <span class="btn success no-bg" @click.prevent="cancelClick">
                    <icon-base width="21" height="20" viewBox="0 0 20 21" icon-name="Success"><icon-deny/></icon-base>
                    <span>NO</span>
                </span>
                <span class="btn danger will-delete-btn" @click.prevent="confirmClick">
                    <icon-base width="21" height="20" viewBox="0 0 20 21" icon-name="Delete"><icon-delete/></icon-base>
                    <span>{{btnText}}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import IconBase from "../common/IconBase";
import IconDeny from "../common/icons/IconDeny";
import IconDelete from "../common/icons/IconDelete";

export default {
    name: 'confirm-component',

    components: {IconDelete, IconDeny , IconBase},

    computed: {
        ...mapState({
            popupData: state => state.popupData,
        }),
    },

    data() {
        return {
            title: 'Are you sure you want to delete this?',
            btnText: 'DELETE'
        }
    },

    mounted() {
        this.title = this.popupData.title !== undefined ? this.popupData.title : this.title;
        this.btnText = this.popupData.btnText !== undefined ? this.popupData.btnText : this.btnText;
    },

    methods: {
        ...mapMutations([
            'switchPopup',
        ]),
        cancelClick() {
            this.switchPopup(false);
        },
        confirmClick() {
            this.popupData.func(this.popupData.id).then(() => {
                this.switchPopup(false);
            }).catch(() => {
                this.switchPopup(false);
            });
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
